import { create } from 'zustand';
import type { OrderResult } from '../types/checkout';
import type { BillingFormData } from '../schemas/billingSchema';

type CheckoutStep = 'contact' | 'billing' | 'payment';

interface CheckoutState {
    currentStep: CheckoutStep;
    completedSteps: Set<CheckoutStep>;
    isSubmitting: boolean;
    orderResult: OrderResult | null;
    gdprConsent: boolean;
    contactEmail: string;
    billingData: BillingFormData | null;
    accountPassword: string;
    setStep: (step: CheckoutStep) => void;
    markStepComplete: (step: CheckoutStep) => void;
    setSubmitting: (flag: boolean) => void;
    setOrderResult: (result: OrderResult) => void;
    setGdprConsent: (consent: boolean) => void;
    setContactEmail: (email: string) => void;
    setBillingData: (data: BillingFormData) => void;
    setAccountPassword: (password: string) => void;
    reset: () => void;
}

export const useCheckoutStore = create<CheckoutState>()((set) => ({
    currentStep: 'contact',
    completedSteps: new Set<CheckoutStep>(),
    isSubmitting: false,
    orderResult: null,
    gdprConsent: true,
    contactEmail: '',
    billingData: null,
    accountPassword: '',
    setStep: (step) => set({ currentStep: step }),
    markStepComplete: (step) =>
        set((state) => ({
            completedSteps: new Set(state.completedSteps).add(step),
        })),
    setSubmitting: (flag) => set({ isSubmitting: flag }),
    setOrderResult: (result) => set({ orderResult: result }),
    setGdprConsent: (consent) => set({ gdprConsent: consent }),
    setContactEmail: (email) => set({ contactEmail: email }),
    setBillingData: (data) => set({ billingData: data }),
    setAccountPassword: (password) => set({ accountPassword: password }),
    reset: () =>
        set({
            currentStep: 'contact',
            completedSteps: new Set<CheckoutStep>(),
            isSubmitting: false,
            orderResult: null,
            gdprConsent: true,
            contactEmail: '',
            billingData: null,
            accountPassword: '',
        }),
}));
